import { getApolloContext } from '@apollo/client';
import { useContext } from 'react';

export default function useApolloClient() {
  const { client } = useContext(getApolloContext());
  return client;
}
